var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [
          _vm._v(_vm._s(_vm.view.name) + " category display content"),
        ]),
        _c("div", { class: _vm.$style.subHeader }, [
          _vm._v(
            " Add or remove content to be displayed on your hotel directory "
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody hotel-directory",
          class: _vm.$style.Body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _c(
            "rb-input",
            { attrs: { "for-id": "name", error: _vm.$showError("name") } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("View Name"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.view.name,
                    expression: "data.view.name",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:100",
                    expression: "'required|max:100'",
                  },
                ],
                staticClass: "rbInput",
                attrs: {
                  id: "name",
                  type: "text",
                  name: "name",
                  autofocus: "",
                  maxlength: "100",
                  placeholder: "view name",
                  "data-vv-as": "view name",
                },
                domProps: { value: _vm.data.view.name },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.data.view, "name", $event.target.value)
                  },
                },
              }),
            ]
          ),
          _c(
            "div",
            { class: _vm.$style.recommendations },
            [
              _vm._v(" Allow user(s) to recommend up to "),
              _c("hd-select", {
                key: _vm.maximumRecommendations,
                attrs: { items: _vm.recommendations },
                model: {
                  value: _vm.maximumRecommendations,
                  callback: function ($$v) {
                    _vm.maximumRecommendations = $$v
                  },
                  expression: "maximumRecommendations",
                },
              }),
              _vm._v(" hotels "),
            ],
            1
          ),
          _vm.rfps && _vm.rfps.length > 0
            ? [
                _c("div", { class: _vm.$style.rfpsTitle }, [
                  _c("h3", { class: _vm.$style.cardTitle }, [
                    _vm._v("Include hotels from these RFPs"),
                  ]),
                  _c("h3", { class: _vm.$style.cardTitle }, [
                    _vm._v("Program Year"),
                  ]),
                ]),
                _c("h5", { class: _vm.$style.rfpSubTitle }, [
                  _vm._v(
                    " When no RFP is selected, hotels from all your RFPs will be displayed on the hotel directory "
                  ),
                ]),
                _c(
                  "div",
                  { class: _vm.$style.rfps },
                  [
                    _vm.rfps.length > 1
                      ? _c(
                          "div",
                          { class: _vm.$style.rfp },
                          [
                            _c("check-box", {
                              class: _vm.$style.columnCheckbox,
                              attrs: {
                                value:
                                  _vm.includeAllRfps ||
                                  _vm.data.view.rfpIds.length ===
                                    _vm.rfps.length,
                                "check-box-value": true,
                                "check-box-label": "All Rfps",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.toggleAllRfps()
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._l(_vm.rfps, function (rfp) {
                      return _c(
                        "div",
                        { key: rfp.id, class: _vm.$style.rfp },
                        [
                          _c("check-box", {
                            class: _vm.$style.columnCheckbox,
                            attrs: {
                              id:
                                _vm.data.view.rfpIds &&
                                _vm.data.view.rfpIds.length + "" + rfp.id,
                              value:
                                _vm.data.view.rfpIds &&
                                _vm.data.view.rfpIds.includes(rfp.id),
                              "check-box-value": true,
                              "check-box-label": rfp.name,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.toggleRfpId(rfp.id)
                              },
                            },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(rfp.programStartDate) +
                                " - " +
                                _vm._s(rfp.programEndDate)
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _c("div", { class: _vm.$style.rfpsTitle }, [
            _c("h3", { class: _vm.$style.cardTitle }, [
              _vm._v("Hotel List View Type"),
            ]),
          ]),
          _c("h5", { class: _vm.$style.rfpSubTitle }, [
            _vm._v(
              " Users can view all hotels (default) or search them by location. If no Locations are uploaded in Locations Manager, users can still search for hotels by city. "
            ),
          ]),
          _c("div", { class: _vm.$style.groupCentered }, [
            _c(
              "div",
              [
                _c("check-box", {
                  staticClass: "light",
                  class: _vm.$style.columnCheckbox,
                  attrs: {
                    value: _vm.data.view.useLocations,
                    "check-box-value": true,
                    "check-box-label": "Use Locations View",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.toggleLocationsView()
                    },
                  },
                }),
              ],
              1
            ),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "rbButton rounded",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.showLocationsCustomMessageEditor()
                    },
                  },
                },
                [_vm._v(" Customize Notification ")]
              ),
            ]),
          ]),
          _c("div", { class: _vm.$style.group }, [
            _c(
              "div",
              { class: _vm.$style.cardBody },
              [
                _c("h3", { class: _vm.$style.cardTitle }, [
                  _vm._v("Display these COLUMNS/FIELDS"),
                ]),
                _vm._l(_vm.columns, function (column) {
                  return _c(
                    "div",
                    { key: column.id },
                    [
                      column.id !== "code"
                        ? _c("check-box", {
                            staticClass: "light",
                            class: _vm.$style.columnCheckbox,
                            attrs: {
                              value:
                                _vm.data.view.columns.indexOf(column.id) > -1,
                              "check-box-value": true,
                              "check-box-label": column.text,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.toggleColumn(column.id)
                              },
                            },
                          })
                        : _c(
                            "div",
                            { class: _vm.$style.codeSelectorGroup },
                            [
                              _c("check-box", {
                                staticClass: "light",
                                class: _vm.$style.columnCheckbox,
                                attrs: {
                                  value: !!_vm.selectedCode,
                                  "check-box-value": true,
                                },
                                on: { input: _vm.toggleCode },
                              }),
                              _c(
                                "hd-select",
                                {
                                  class: _vm.$style.codeDropdown,
                                  attrs: {
                                    value: _vm.selectedCode,
                                    items: _vm.propertyCodes,
                                    disabled: !_vm.selectedCode,
                                  },
                                  on: { input: _vm.selectCode },
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons",
                                      attrs: { slot: "icon" },
                                      slot: "icon",
                                    },
                                    [_vm._v(" info ")]
                                  ),
                                  _c(
                                    "label",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v(_vm._s(column.text))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _c(
              "div",
              { class: _vm.$style.cardBody },
              [
                _c("h3", { class: _vm.$style.cardTitle }, [
                  _vm._v("Display these RATES"),
                ]),
                _vm._l(_vm.rates, function (type) {
                  return _c(
                    "div",
                    { key: type.id },
                    [
                      _c("check-box", {
                        staticClass: "light",
                        attrs: {
                          value: _vm.data.view.rates.indexOf(type.id) > -1,
                          "check-box-value": true,
                          "check-box-label": type.name,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.toggleRateType(type.id)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  [
                    _c("check-box", {
                      staticClass: "light",
                      attrs: {
                        "check-box-value": true,
                        "check-box-label": "Show Blackout Dates",
                      },
                      model: {
                        value: _vm.data.view.showBlackoutDates,
                        callback: function ($$v) {
                          _vm.$set(_vm.data.view, "showBlackoutDates", $$v)
                        },
                        expression: "data.view.showBlackoutDates",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c("check-box", {
                      staticClass: "light",
                      attrs: {
                        "check-box-value": true,
                        "check-box-label": "Show Rate Type",
                      },
                      model: {
                        value: _vm.data.view.showRateTypes,
                        callback: function ($$v) {
                          _vm.$set(_vm.data.view, "showRateTypes", $$v)
                        },
                        expression: "data.view.showRateTypes",
                      },
                    }),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "div",
              { class: _vm.$style.cardBody },
              [
                _c("h3", { class: _vm.$style.cardTitle }, [
                  _vm._v("Display these HOTEL TYPES"),
                ]),
                _vm._l(_vm.hotelTypes, function (type) {
                  return _c(
                    "div",
                    { key: type.id },
                    [
                      _c("check-box", {
                        staticClass: "light",
                        attrs: {
                          value: _vm.data.view.hotelTypes.indexOf(type.id) > -1,
                          "check-box-value": true,
                          "check-box-label": type.name,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.toggleHotelType(type.id)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.canDelete
            ? _c(
                "button",
                {
                  staticClass: "rbButton",
                  class: _vm.$style.left,
                  attrs: { type: "button" },
                  on: { click: _vm.drop },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("delete"),
                  ]),
                  _vm._v(" Delete View "),
                ]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
            _vm._v(" Save Changes "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }